



















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Emit, Prop } from 'vue-property-decorator'
import QInput from 'quasar/src/components/input/QInput.js';

@Component
export default class PinInput extends Vue {
  @Prop({ default: 4 }) digits!: number

  code = ''

  $refs!: {
    input: QInput[]
  }

  @Emit()
  submitCode() {
    return this.code
  }

  enterNumber(e) {
    const numberOfInput = Number(e.target.attributes['data-index'].value)
    const typeOfInput = e.inputType
    const currentInput = this.$refs.input
    const stepMoveInput = 1
    const valuesOfInputs = this.$refs.input.map((input) => input.value).join('')

    if (typeOfInput === 'insertText') {

      if (currentInput[numberOfInput + stepMoveInput]) {

        currentInput[numberOfInput + stepMoveInput].focus()

        if (valuesOfInputs.length === this.digits) {
          this.code = valuesOfInputs
          this.submitCode()
        }

      } else {

        if (valuesOfInputs.length === this.digits) {
          this.code = valuesOfInputs
          this.submitCode()
        }

      }

    }

    if (typeOfInput === 'deleteContentBackward') {

      if (currentInput[numberOfInput - stepMoveInput]) {

        currentInput[numberOfInput - stepMoveInput].focus()

      }
    }
  }
}
